import { postJSON } from "./api";
import type { GetProToken } from "../hooks/useProToken";

// Confirm-card send actions (plan 188 W2-M8, task 803). Every function here
// calls an EXISTING REST endpoint the manual Pro CRM UI already uses — the
// copilot's draft tools (backend/internal/agent/tools/pro_drafts.go) never
// call these themselves (D5). A confirm card's Send button is the only
// caller.

export type SendClientMessageResponse = { sent: boolean; channel: string };

// Plan 377 M5 (REST surface): the draft_message confirm card's Send button
// calls the contact-keyed people route directly — the profile-keyed
// /clients/:profileId/message route is retired (design spec §4.1).
export async function sendPersonMessage(
  contactId: string,
  input: { subject: string; body: string },
  getToken: GetProToken,
): Promise<SendClientMessageResponse> {
  const token = await getToken();
  return postJSON<SendClientMessageResponse>(
    `/api/professional/people/${contactId}/message`,
    input,
    token ?? undefined,
  );
}

export type SendInvitesResponse = {
  sent: string[];
  skipped_already_sent: string[];
  skipped_cooldown: string[];
  invalid: string[];
};

export async function sendInvites(
  contactIds: string[],
  message: string | undefined,
  getToken: GetProToken,
): Promise<SendInvitesResponse> {
  const token = await getToken();
  return postJSON<SendInvitesResponse>(
    "/api/professional/invites",
    { contact_ids: contactIds, ...(message ? { message } : {}) },
    token ?? undefined,
  );
}
